/* eslint-disable no-console */
export const postTokenToParent = (token: string): void => {
  try {
    const { REACT_APP_PARENT_ORIGIN } = process.env;
    window.parent.postMessage(JSON.stringify({ token }), REACT_APP_PARENT_ORIGIN || "*");
  } catch (error) {
    console.error("Failed to post message to parent window:", error);
  }
};
